import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import Default from 'react-bootstrap/Card';
import { Media } from '../media/media.esm.js';
import { Body } from '../text/body/body.esm.js';
import { Description } from '../text/description/description.esm.js';
import { Title } from '../text/title/title.esm.js';
import { TabIndicator } from './components/tab-indicator.esm.js';

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Use standard HTML elements with Bootstrap card classes instead.
 * See: https://getbootstrap.com/docs/5.3/components/card/
 */ const _Card = ({ children, className, accentBar, cornerSize = 'md', style, ...rest }, ref)=>{
    // Show deprecation warning in development
    if (process.env.NODE_ENV === 'development') {
        console.warn('⚠️  Card component is deprecated and will be removed in a future version.\n' + 'Please use standard HTML elements with Bootstrap card classes:\n' + '• Use <div className="card"> for basic card structure\n' + '• Use Bootstrap border radius classes (rounded, rounded-lg) instead of cornerSize\n' + 'See: https://getbootstrap.com/docs/5.3/components/card/');
    }
    return jsxs(Default, {
        /**
         * Surpresses the hydration warning when using the card component in the carousel
         * as we do not know the users breakpoint when the component is rendered on the server.
         */ suppressHydrationWarning: true,
        className: classNames({
            'card-accent-bar': accentBar,
            'card-corner-size-large': cornerSize === 'lg'
        }, className),
        ref: ref,
        style: style,
        ...rest,
        children: [
            accentBar && jsx("div", {
                className: "accent-bar"
            }),
            children
        ]
    });
};
/**
 * @deprecated These custom components are deprecated. Use standard HTML elements with Bootstrap classes directly.
 */ const customComponents = {
    /**
     * Custom components
     * @deprecated Use standard HTML elements with Bootstrap classes instead
     */ Subtitle: Description,
    Text: Body,
    Title,
    Media: ({ aspectRatio, objectFit, ...rest })=>jsx(Media, {
            hideBorder: true,
            aspectRatio: aspectRatio,
            objectFit: objectFit || 'cover',
            ...rest
        }),
    TabIndicator
};
/**
 * @deprecated Use standard HTML elements with Bootstrap card classes instead
 */ const defaultComponents = {
    /**
     * Default react-bootstrap components
     * @deprecated Use standard HTML elements with Bootstrap card classes instead
     */ Img: Default.Img,
    Body: Default.Body,
    Link: Default.Link,
    Header: Default.Header,
    Footer: Default.Footer,
    ImgOverlay: Default.ImgOverlay
};
const _CardWithRef = /*#__PURE__*/ forwardRef(_Card);
/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Use standard HTML elements with Bootstrap card classes instead.
 * See: https://getbootstrap.com/docs/5.3/components/card/
 */ const Card = Object.assign(_CardWithRef, customComponents, defaultComponents);

export { Card };
